import i18n from 'simple-react-i18n'

const INDICATOR_OBJECT_TYPE = {
    RESOURCE: 1,
    PRODUCTION_UNIT: 2,
}

const INDICATOR_TYPE = {
    WATER_STRESS: 1,
}

const CALCULATION_MODES = {
    CLASSIC: 1,
    IAEAU: 2,
}

const RETURN_PERIOD_BANDS = [
    { code: 'aboveWetFiveYears', color: '#c6d2ea', bound: 'PERIOD_5_H', above: true },
    { code: 'wetFiveYears', color: '#bcdcf2', bound: 'PERIOD_5_H' },
    { code: 'wetThreeYears', color: '#cbe7bf', bound: 'PERIOD_3_H' },
    { code: 'dryThreeYears', color: '#f9edb2', bound: 'ENVELOPPE_AVERAGE', dashed: true },
    { code: 'dryFiveYears', color: '#f9d69a', bound: 'PERIOD_3_S' },
    { code: 'belowDryFiveYears', color: '#f5b3ad', bound: 'PERIOD_5_S' },
]

const MIN_SCORE = 0
const MAX_SCORE = 100

const SCORE_ANCHORS = {
    aboveWetFiveYears: 80,
    wetFiveYears: 66.7,
    wetThreeYears: 50,
    dryThreeYears: 33.3,
    dryFiveYears: 20,
    belowDryFiveYears: MIN_SCORE,
}

const SCORE_BANDS = RETURN_PERIOD_BANDS.map(({ code, color }, index) => ({
    code,
    color,
    from: SCORE_ANCHORS[code],
    to: index === 0 ? MAX_SCORE : SCORE_ANCHORS[RETURN_PERIOD_BANDS[index - 1].code],
}))

const SCORE_AXIS = { min: MIN_SCORE, max: MAX_SCORE, interval: 20 }

const getObjectTypes = () => [
    { code: INDICATOR_OBJECT_TYPE.RESOURCE, name: i18n.resources },
    { code: INDICATOR_OBJECT_TYPE.PRODUCTION_UNIT, name: i18n.productionUnits },
]

const getIndicatorTypes = () => [
    { code: INDICATOR_TYPE.WATER_STRESS, name: i18n.waterStress },
]

export {
    INDICATOR_OBJECT_TYPE,
    INDICATOR_TYPE,
    CALCULATION_MODES,
    MIN_SCORE,
    MAX_SCORE,
    SCORE_BANDS,
    SCORE_AXIS,
    RETURN_PERIOD_BANDS,
    getObjectTypes,
    getIndicatorTypes,
}